import React from 'react';
import { withTranslation } from 'react-i18next';
import ListManual from './ListManual';
import "./manuals.css";

function User({ t }) {
    const manuals = [
        {
            "url": "https://owncloud.signaturit.com/s/rtYJzmgIFFmvfpK",
            "title": t('manuals.user.vidSignerAndroid'),
            "description": t('manuals.user.vidSignerDesc')
        },
        {
            "url": "https://owncloud.signaturit.com/s/JprJas17qfVuRyz",
            "title": t('manuals.user.vidSigneriOS'),
            "description": t('manuals.user.vidSigneriOSDesc')
        },
        {
            "url": "https://owncloud.signaturit.com/s/eF2EU48lL4hDbPb",
            "title": t('manuals.user.vidSignerWindows'),
            "description": t('manuals.user.vidSignerWindowsDesc')
        },
        {
            "url": "https://owncloud.signaturit.com/s/F1QORwT264lvuxf",
            "title": t('manuals.user.vidRemote'),
            "description": t('manuals.user.vidRemoteDesc')
        },
        {
            "url": "https://owncloud.signaturit.com/s/oISCQyIppYnfCUJ",
            "title": t('manuals.user.centralized'),
            "description": t('manuals.user.centralizedDesc')
        },
        {
            "url": "https://owncloud.signaturit.com/s/XlXF4RuKJjTuwgn",
            "title": t('manuals.user.edelivery'),
            "description": t('manuals.user.edeliveryDesc')
        }
    ];

    return <ListManual links={manuals} />;
}

export default withTranslation()(User);